// Simple expandable section: button header + conditional body. Deliberately not
// the same component as `CollapsibleBlock` in pages/skill.jsx — that one is coupled
// to the onboarding page's i18n keys (skill.scopes.more/less) and visual rhythm.
// This is a plain, workspace-styled building block for any collapsible form section.

import React, { useState } from 'react';
import { XIcons } from '../primitives.jsx';

export function CollapsibleSection({ title, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div
      className="card"
      style={{ border: '1px solid var(--line)', borderRadius: 10, overflow: 'hidden' }}
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="row between"
        style={{
          width: '100%',
          padding: '12px 16px',
          background: 'var(--bg-1)',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--fg-1)',
          fontSize: 13,
          fontWeight: 600,
          alignItems: 'center',
        }}
      >
        <span>{title}</span>
        <XIcons.IconChevronDown
          size={14}
          style={{
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .15s',
            color: 'var(--fg-3)',
          }}
        />
      </button>
      {open && (
        <div style={{ padding: 16, borderTop: '1px solid var(--line)' }}>
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleSection;
